/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */
/**
 * @module selection
 */
/** @internal */
export const WRAP = 'wrap';
/** @internal */
export const UNWRAP = 'unwrap';
/** @internal */
export const CHANGE = 'change';
/** @internal */
export const UNSET = 'unset';
/** @internal */
export const INITIAL = 'initial';
/** @internal */
export const REPLACE = 'replace';
/** @internal */
export const _PREFIX = 'commitStyle';
